"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var react_1 = __importDefault(require("react"));
var TextInputs_1 = require("../../../TextInputs");
var SearchBar = function (_a) {
    var searchbarPlaceholder = _a.searchbarPlaceholder, searchBarFocus = _a.searchBarFocus, searchString = _a.searchString, setSearchString = _a.setSearchString, setSearchBarFocus = _a.setSearchBarFocus;
    return (react_1.default.createElement("div", { style: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            padding: "4px 0",
            background: "white"
        }, onBlur: function () { return setSearchBarFocus(false); }, tabIndex: 0 },
        react_1.default.createElement("div", { style: { paddingBottom: "4px" } },
            react_1.default.createElement(TextInputs_1.TextInput, { placeholder: searchbarPlaceholder, forceFocus: searchBarFocus, type: "text", icon: "MagnifyingGlass", value: searchString, onChange: function (k, v) { return setSearchString(v); }, S: true }))));
};
exports.SearchBar = SearchBar;
